import React, { Fragment, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import Menu from '@mui/material/Menu';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import estilos from './MenuHamburguesaHolograma.module.css'; { {/*Estilos para el componente*/ } }

import { BrowserRouter as Router, Switch, Route, NavLink } from "react-router-dom";

import {
    faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faCheckDouble, faClock, faCalendar,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faPenToSquare, faEdit, faPersonWalking, faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons'

library.add(faCheckSquare, faCoffee, faEye, faUsers, faUser, faHandshake, faUserGroup, faUserCheck, faPersonRunning, faEraser, faEnvelope,
    faCheck, faPenToSquare, faCheckDouble, faClock, faPersonWalking, faRightFromBracket,
    faIndustry, faMoneyBill, faCircleInfo, faPerson, faWineBottle, faDumpster, faXmark, faCalendar)


const BotonMenuHamburguesa = (props) => {

    const currentUser = useSelector(store => store.Usuario.data)
    let idUsuario = 0
    if (currentUser) {
        idUsuario = currentUser.user[0].id
    }


    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const mapOpciones = props.opciones;
    return (
        <Fragment>
            <div>
                <NavLink exact to={props.ruta} className={`${estilos.nav_link}`} >
                    <FontAwesomeIcon icon={faCalendar} />
                    <Button id="basic-button" aria-controls={open ? 'basic-menu' : undefined} aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined} onClick={handleClick} sx={{ color: 'white' }} >
                        <div className={`${estilos.nav_name} text-wrap`}>{props.titulo}</div>
                    </Button>
                </NavLink>


                {Object.keys(props.objeto).length === 0 ?
                    <Fragment></Fragment>
                    :
                    <Fragment>
                        <Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} MenuListProps={{ 'aria-labelledby': 'basic-button', }} >
                            {props.objeto.map(item =>
                                <NavLink key={item.ruta} exact to={item.ruta} >
                                    <MenuItem onClick={handleClose}>{item.text}</MenuItem>
                                </NavLink>
                            )}
                        </Menu>
                    </Fragment>
                }

            </div>
        </Fragment>
    );
};
export default withRouter(BotonMenuHamburguesa)
